import {
  MarketDetails,
  PerformanceContainer,
  PerformanceItem,
  PerformanceListWrapper,
  PerformancePageWrapper,
  PerformanceTitle,
  ProductContainerMobile,
  ProductDetails,
  ProductDetailsContainer,
  ProductImageWrapper,
  ProductNameAndDescription,
  SkeletonWrapper,
  StyledHeader,
} from './style'
import ProductItem from './item'
import React from 'react'
import { SplashContainer } from '../splash/style'
import { byProductMarketcap } from 'pages/overview/service'
import { ProductOverview } from '../../storage/interface'
import { getAllProducts } from 'indices-list'
import { noStakingProduct } from 'utils/product-service'
import Skeleton from 'react-loading-skeleton'

interface PerformanceProps {
  products: ProductOverview[]
}

const LoadingItem = (): JSX.Element => {
  return (
    <PerformanceItem>
      <ProductDetails>
        <ProductImageWrapper>
          <SkeletonWrapper>
            <Skeleton circle={true} height={48} width={48} />
          </SkeletonWrapper>
        </ProductImageWrapper>
        <ProductNameAndDescription>
          <div>
            <Skeleton width={120} />
          </div>
          <div>
            <Skeleton width={80} />
          </div>
        </ProductNameAndDescription>
      </ProductDetails>
      <ProductContainerMobile>
        <ProductDetailsContainer>
          <StyledHeader>
            <Skeleton width={60} />
          </StyledHeader>
          <SkeletonWrapper>
            <Skeleton width={60} />
          </SkeletonWrapper>
        </ProductDetailsContainer>
        <ProductDetailsContainer>
          <StyledHeader>
            <Skeleton width={60} />
          </StyledHeader>
          <SkeletonWrapper>
            <Skeleton width={60} />
          </SkeletonWrapper>
        </ProductDetailsContainer>
        <ProductDetailsContainer>
          <StyledHeader></StyledHeader>
          <SkeletonWrapper>
            <Skeleton width={60} />
          </SkeletonWrapper>
        </ProductDetailsContainer>
      </ProductContainerMobile>
      <MarketDetails>
        <Skeleton width={280} height={30} borderRadius="1.35rem" />
      </MarketDetails>
    </PerformanceItem>
  )
}

/**
 * This is the second section of the overview page (Product exposure)
 * @returns
 */

const MobileProductExposure: React.FC<PerformanceProps> = ({ products }) => {
  const productList = getAllProducts().filter(noStakingProduct)
  return (
    <PerformancePageWrapper>
      <SplashContainer>
        <PerformanceContainer id="content">
          <PerformanceTitle>Total exposure through one token</PerformanceTitle>
          <PerformanceListWrapper>
            {products.length !== 0
              ? products
                  .sort(byProductMarketcap)
                  .map((product: ProductOverview) => (
                    <ProductItem key={product.address} product={product} />
                  ))
              : productList.map((el) => {
                  return <LoadingItem key={el.address} />
                })}
          </PerformanceListWrapper>
        </PerformanceContainer>
      </SplashContainer>
    </PerformancePageWrapper>
  )
}
export default MobileProductExposure
